import { has } from "../../../../utils/menu-context";
import store from "../../../../store";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (store.state?.resource?.auth?.info?.user?.refOfficerLv) {
                return false;
            }
            if ([undefined, "draft", "reEdit"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWait: ({ record }) => {
            let result = false;
            if (["draft", "reEdit"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canCancel: ({ record }) => {
            let result = false;
            if (["wait", "reEdit"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = ({ dataKey }) => {
    const prefix = dataKey ? `${dataKey}.` : "";
    const prefixRegExp = dataKey ? `${dataKey}\\.` : "";
    return [
        {
            check: ({ field }) => {
                return [`${prefix}lastStatus.forFromRemark.0.remark`].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["wait", "approve", "notApprove", "cancel"]
            })
        },
        {
            check: ({ field }) => {
                return [`${prefix}lastStatus.forToRemark.0.remark`].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [undefined, "draft", "reEdit", "approve", "notApprove", "cancel"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}(refType)$`, "g").test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["wait", "reEdit", "approve", "notApprove", "cancel"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}(refTo)$`, "g").test(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refType?.key === "1";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["wait", "reEdit", "approve", "notApprove", "cancel"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}(toOther)$`, "g").test(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refType?.key === "2";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["wait", "approve", "notApprove", "cancel"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}storageLocations\\.[^\\.]+\\.(refHaz|refHazLicenseFrom|refStorageLocation)$`, "g").test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["wait", "reEdit", "approve", "notApprove", "cancel"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}storageLocations\\.[^\\.]+\\.(amount)$`, "g").test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["wait", "approve", "notApprove", "cancel"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^${prefixRegExp}attachments\\.[^\\.]+$`, "g").test(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refType?.key === "2";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["wait", "approve", "notApprove", "cancel"]
            })
        }
    ];
};

export const commonInputPropField = ({ disabledStatuses }) => ({ initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses.includes(initialModel.refStatus?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};
